import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router";

type ResourceLinkProps = {
  field: string;
  url: string;
  resourceValue: string;
  state?: Record<string, unknown>;
};

const ResourceLink = ({
  url,
  resourceValue,
  field,
  state,
}: ResourceLinkProps) => {
  const theme = useTheme();
  return (
    <Link data-testid={`${field}-resource-link`} to={url} state={state}>
      <Typography
        sx={{
          color: theme.tokens.FuelColorTextBrandPrimary,
          fontWeight: theme.tokens.FuelFontWeightRegular,
          fontSize: "14px",
          textDecoration: "underLine",
          ":hover": {
            cursor: "pointer",
            color: theme.tokens.FuelColorFocused,
          },
        }}
      >
        {resourceValue}
      </Typography>
    </Link>
  );
};

export default ResourceLink;
